import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanCreateVehicle = (): boolean => {
  const [canCreateVehicle, setCanCreateVehicle] =
    React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const createAllPermission: Permission = {
    resource: 'vehicles',
    action: 'createbasic',
    scope: 'all',
  };
  const createProviderPermission: Permission = {
    resource: 'vehicles',
    action: 'createbasic',
    scope: 'provider',
  };

  const canCreateAll = useHasPermission(user, createAllPermission);
  const canCreateProvider = useHasPermission(user, createProviderPermission);

  React.useEffect(() => {
    setCanCreateVehicle(canCreateAll || canCreateProvider);
  }, [canCreateAll, canCreateProvider]);

  return canCreateVehicle;
};
